export const NOTIFICATION_COUNT_QUERY = '/action-centre/notifications';
export const CONNECTION_REQUESTS_QUERY = '/connections/requests';
export const CONNECTION_REQUESTS_SEARCH_QUERY = '/connection-requests/search';
export const CONNECTION_REQUESTS_SEARCH_EXPORT_QUERY = '/connection-requests/search/export';
export const MERGE_REQUESTS_QUERY = '/merge-requests';
export const REMEDIATION_REQUESTS_SEARCH_QUERY = '/remediation-requests/search';
export const ASSESSMENT_REVIEWS_QUERY = '/assessment/reviews';
